import BaseAPI from 'web/redux/actions/BaseAPI';
import store from 'web/redux/store';
import enumList from 'web/utils/enumList';
import {showMessage} from 'web/utils/modalHelper';

/**
 *
 */
export default function useCaseDetail() {
  const validate = () => {
    // TODO: Appearance content validation
  };

  const fetchData = async ({id}) => {
    const token = store.getState().auth.token;
    try {
      const response =
        await BaseAPI.getWithAuth(`/appearances/${id}`, undefined, token);

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const fetchSkills = async () => {
    const token = store.getState().auth.token;
    try {
      const response =
        await BaseAPI.getWithAuth('/condition', undefined, token);

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const create = async ({data}) => {
    const token = store.getState().auth.token;
    try {
      const response =
        await BaseAPI.postWithAuth('/appearances', data, token);

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const update = async ({id, data}) => {
    const token = store.getState().auth.token;
    try {
      const response =
        await BaseAPI.putWithAuth(`/appearances/${id}`, data, token);

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  return {
    validate,
    fetchData,
    fetchSkills,
    create,
    update,
  };
};
